import firebase from 'firebase/app'
import 'firebase/database'

const firebaseConfig = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
}

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig)
}

const db = firebase.database()

export { db }